var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportsBigIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67,
    height: 87,
    viewBox: "0 0 67 87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reportsBigIcon",
    transform: "translate(-16.5 -958.862)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11277",
    "data-name": "Path 11277",
    d: "M21,959.362a3.991,3.991,0,0,0-4,4v78a3.991,3.991,0,0,0,4,4H79a3.991,3.991,0,0,0,4-4v-78a3.991,3.991,0,0,0-4-4ZM43.031,971.3a2,2,0,0,1,1.5,3.344l-10,12a2.084,2.084,0,0,1-2.937.125l-6-6a2,2,0,1,1,2.812-2.844l4.469,4.469,8.594-10.312a2.265,2.265,0,0,1,1.562-.781ZM49,980.362H73a2,2,0,0,1,0,4H49a2,2,0,0,1,0-4ZM43.031,993.3a2,2,0,0,1,1.5,3.344l-10,12a2.084,2.084,0,0,1-2.937.125l-6-6a2,2,0,1,1,2.812-2.844l4.469,4.469,8.594-10.312a2.265,2.265,0,0,1,1.562-.781ZM49,1002.362H73a2,2,0,0,1,0,4H49a2,2,0,0,1,0-4ZM43.031,1015.3a2,2,0,0,1,1.5,3.344l-10,12a2.084,2.084,0,0,1-2.937.125l-6-6a2,2,0,1,1,2.812-2.844l4.469,4.469,8.594-10.312a2.023,2.023,0,0,1,1.312-.75,1.923,1.923,0,0,1,.25-.031ZM49,1024.362H73a2,2,0,0,1,0,4H49a2,2,0,0,1,0-4Z",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsBigIcon);
export default __webpack_public_path__ + "static/media/reportsBigIcon.22cd65c9895f5085cb19e9b0966c97d9.svg";
export { ForwardRef as ReactComponent };